import { useQuery } from "@tanstack/react-query";
import { Link, NavLink } from "react-router-dom";
import { getMemberProfile } from "../lib/memberService";
import { listTraining } from "../lib/workflowService";
import "../member-final.css";

export function TrainingPage() {
  const profile = useQuery({ queryKey: ["profile"], queryFn: getMemberProfile });
  const training = useQuery({ queryKey: ["training"], queryFn: listTraining });
  const available = (training.data ?? []).filter((item) => !item.locked && (item.minimumLevel <= (profile.data?.level ?? 0)));
  const locked = (training.data ?? []).filter((item) => item.locked || item.minimumLevel > (profile.data?.level ?? 0));

  return (
    <div className="member-app standalone-member-page">
      <header className="member-header">
        <Link className="member-logo" to="/app"><span>H</span><b>THE HOUSE</b></Link>
        <div className="member-header-actions"><NavLink to="/app" end>OFFERS</NavLink><NavLink to="/app/earnings">EARNINGS</NavLink></div>
      </header>
      <main>
        <section className="standalone-member-hero">
          <span>TRAINING LIBRARY</span>
          <h1>Get sharper.<br />Unlock better work.</h1>
          <p>Use the same SOPs, examples, and frameworks that power real paid tasks inside The House.</p>
        </section>
        <section>
          <div className="member-section-head"><div><span>AVAILABLE NOW</span><h2>Your training</h2></div></div>
          <div className="training-grid">
            {available.map((item) => <a href={item.url} target="_blank" rel="noreferrer" key={item.id}><span>{item.kind.toUpperCase()} · LEVEL {item.minimumLevel}</span><h3>{item.title}</h3><p>{item.description}</p><b>OPEN TRAINING →</b></a>)}
          </div>
        </section>
        {locked.length > 0 && <section className="locked-training"><div className="member-section-head"><div><span>KEEP MOVING</span><h2>Next unlocks</h2></div></div>{locked.map((item) => <article key={item.id}><span>L{item.minimumLevel}</span><div><b>{item.title}</b><p>{item.description}</p></div><small>LOCKED</small></article>)}</section>}
      </main>
    </div>
  );
}
